import { Component, inject } from '@angular/core';
import { CategorySelectorComponent } from '../../../custom-input/category-selector/category-selector.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { TransportFormService } from 'src/app/trip-calculator/services/transport-form.service';
import { TransportCategory } from 'src/app/trip-calculator/models/transport';

@Component({
  selector: 'app-select-transport-category',
  imports: [CategorySelectorComponent, TranslocoPipe, ButtonModule],
  templateUrl: './select-transport-category.component.html',
})
export class SelectTransportCategoryComponent {
  transportFormService = inject(TransportFormService);

  get transportCategory() {
    return this.transportFormService.transportCategory();
  }

  set transportCategory(value: string | null) {
    this.transportFormService.transportForm.get('type')?.reset();
    this.transportFormService.resetCalculationMode();
    this.transportFormService.transportCategory.set(value as TransportCategory);
  }
}
